/** @jsx jsx */

import type { WithDataAttributeProp } from '@balance-web/core';
import { buildDataAttributes, jsx } from '@balance-web/core';
import { forwardRefWithAs } from '@balance-web/utils';

import type { BoxStyleProps } from './useBoxStyles';
import { useBoxStyles } from './useBoxStyles';

export type BoxProps = WithDataAttributeProp<{
  id?: string;
}> &
  BoxStyleProps;

export const Box = forwardRefWithAs<'div', BoxProps>(
  ({ as: Tag = 'div', ...props }, ref) => {
    const {
      // box props
      id,
      data,

      // style props
      alignSelf,
      background,
      border,
      borderRadius,
      borderWidth,
      bottom,
      boxShadow,
      cursor,
      flex,
      flexBasis,
      flexGrow,
      flexShrink,
      gridArea,
      gridColumn,
      gridColumnEnd,
      gridColumnStart,
      gridRow,
      gridRowEnd,
      gridRowStart,
      height,
      justifySelf,
      left,
      margin,
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      marginX,
      marginY,
      maxHeight,
      maxWidth,
      minHeight,
      minWidth,
      overflow,
      overflowX,
      overflowY,
      padding,
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingTop,
      paddingX,
      paddingY,
      position,
      right,
      top,
      userSelect,
      width,
      zIndex,
      ...attrs
    } = props;

    const boxStyles = useBoxStyles({
      alignSelf,
      background,
      border,
      borderRadius,
      borderWidth,
      bottom,
      boxShadow,
      cursor,
      flex,
      flexBasis,
      flexGrow,
      flexShrink,
      gridArea,
      gridColumn,
      gridColumnEnd,
      gridColumnStart,
      gridRow,
      gridRowEnd,
      gridRowStart,
      height,
      justifySelf,
      left,
      margin,
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      marginX,
      marginY,
      maxHeight,
      maxWidth,
      minHeight,
      minWidth,
      overflow,
      overflowX,
      overflowY,
      padding,
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingTop,
      paddingX,
      paddingY,
      position,
      right,
      top,
      userSelect,
      width,
      zIndex,
    });

    return (
      <Tag
        ref={ref}
        css={boxStyles}
        id={id}
        {...(data ? buildDataAttributes(data) : undefined)}
        {...attrs}
      />
    );
  }
);

Box.displayName = 'Box';
